// src/Announcements.js
function Announcements() {
    return <div>Welcome to the Announcements</div>;
  }
  
  export default Announcements;
  